export default "__VITE_ASSET__CZOupO_t__"